export default __webpack_public_path__ + "aa52c4996c005a95161142f58300dbb4.svg";